import { EntityRepository, Repository, getManager } from "typeorm";
import { EnquiriesEntity } from "../entites/enquiries";
import { EnquiryAssessmentInfoReq, EnquiryIdreq, EnquiryLifecycleStatusEnum, FreezeUnFreezeInfoReq } from "@gtpl/shared-models/enquiry-management";
import appSettings from "apps/services/config";
import { CompanyCategoryEnum } from "@gtpl/shared-models/raw-material-procurement";
import { HarvestTypes } from "@gtpl/shared-models/common-models";

@EntityRepository(EnquiriesEntity)
export class EnquiriesRepository extends Repository<EnquiriesEntity>{

        async getAllEnquiriesByStatus(req: EnquiryAssessmentInfoReq): Promise<any> {
            const manager = getManager();
            let infoQuery = `SELECT enquiry_id,enquiry_number,source_from,etd,uni.unit_name,cou.country_name,des.destination_name,cus.client_name,endcus.end_customer_name,enquiry_date,life_cycle_status
            FROM enquiries enq 
            LEFT JOIN `+appSettings.masters_db+` .countries cou on cou.country_id = enq.country_id
            LEFT JOIN `+appSettings.masters_db+` .destination des on des.destination_id = enq.destination_id
            LEFT JOIN `+appSettings.masters_db+` .unitcodes uni on uni.unit_code_id = enq.unit_id
            LEFT JOIN `+appSettings.masters_db+` .customers cus on cus.cust_id = enq.agent_id
            LEFT JOIN `+appSettings.masters_db+` .end_customers endcus on endcus.end_customer_id = enq.buyer_id
            WHERE enquiry_id > 0 `
            if(req.tabName == 'Assessment'){
                infoQuery += ` and life_cycle_status = '${req.status}'`
            }
            if(req.tabName == 'Freezed'){
                infoQuery += ` and freeze_status = 1`
            }
            if(req.tabName == 'UnFreezed'){
                infoQuery += ` and freeze_status = 0 and life_cycle_status IN('${EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED}','${EnquiryLifecycleStatusEnum.COSTING_APPROVED}','${EnquiryLifecycleStatusEnum.RENEGOTIATED}','${EnquiryLifecycleStatusEnum.QUOTATION_SENT}','${EnquiryLifecycleStatusEnum.ACCEPTANCE_PENDING}')`
            }
            if (req.country !== undefined) {
                infoQuery += ` and enq.country_id = ${req.country}`;
            }
            if(req.destination != undefined){
                infoQuery +=  ` and enq.destination_id = ${req.destination}`
            }
            if(req.enquiryNumber != undefined){
                infoQuery +=  ` and enq.enquiry_number = '${req.enquiryNumber}'`
            }
            if(req.unit != undefined){
                infoQuery +=  ` and enq.unit_id = ${req.unit}`
            }
            if(req.fromDate != undefined){
                infoQuery += ` and enq.enquiry_date between '${req.fromDate}' and '${req.toDate}'`
            }
            infoQuery += ` order by enquiry_date`
            return await  manager.query(infoQuery)   
        }

        async getCountryInfoDropdown():Promise<any>{
            const manager = getManager()
            let infoQuery = `select enq.country_id as countryId,cou.country_name as countryName from enquiries enq left join `+appSettings.masters_db+` .countries cou on cou.country_id = enq.country_id group by enq.country_id`
            return await manager.query(infoQuery)
        }

        async getDestinationInfoDropdown():Promise<any>{
            const manager = getManager()
            let infoQuery = `select enq.destination_id as destinationId,des.destination_name as destinationName from enquiries enq left join `+appSettings.masters_db+` .destination des on des.destination_id = enq.destination_id group by enq.destination_id`
            return await manager.query(infoQuery)
        }

        async getUnitInfoDropdown():Promise<any>{
            const manager = getManager()
            let infoQuery = `select enq.unit_id as unitId,uni.unit_name as unitName from enquiries enq left join `+appSettings.masters_db+` .unitcodes uni on uni.unit_code_id = enq.unit_id group by enq.unit_id`
            return await manager.query(infoQuery)
        }
        async getmaxId():Promise<any>{
            const id= await this.createQueryBuilder('e')
            .select(`max(enquiry_id) as enquiryId`)
            .orderBy(` created_at`, 'DESC')
            return await id.getRawOne()
        }

        async getEnquiryInfoByEnquiryId(id:number):Promise<any>{
            const manager = getManager()
            let infoQuery = `select enq.enquiry_number as enquiryNumber,rsn.reasons_name as rejectReason,cou.country_name as countryName,des.destination_name as destinationName, uni.unit_name as unitName, endcus.end_customer_name as buyerName,enq.unit_id as unitId from enquiries enq left join `+appSettings.masters_db+` .countries cou on cou.country_id = enq.country_id left join `+appSettings.masters_db+` .destination des on des.destination_id = enq.destination_id left join `+appSettings.masters_db+` .unitcodes uni on uni.unit_code_id = enq.unit_id left join `+appSettings.masters_db+` .end_customers endcus on endcus.end_customer_id = enq.buyer_id left join `+appSettings.masters_db+` .reasons rsn on rsn.reasons_id = enq.enquiry_reject_reason where enq.enquiry_id = ${id}`
            return await manager.query(infoQuery)
                    }
        async getEnquiryLogsAging(enquiryId:number):Promise<any>{
            const manager = getManager()
            let query='SELECT MAX(enquiry_log_id),MAX(enquiry_log_id)-1,DATEDIFF((SELECT created_at FROM enquiry_log WHERE enquiry_log_id=(SELECT MAX(enquiry_log_id) FROM enquiry_log)), (SELECT created_at FROM enquiry_log WHERE enquiry_log_id=(SELECT MAX(enquiry_log_id)-1 FROM enquiry_log))) AS diff     FROM  enquiry_log where enquiry_id='+enquiryId+''
            return await manager.query(query)
        }

        async getCostPriceInfo():Promise<any>{
            const manager = getManager()
            let infoQuery = `SELECT count,price,updated_at FROM `+appSettings.rm_procure_db+` .rm_rates WHERE category = '${CompanyCategoryEnum.OWN}' AND type = '${HarvestTypes.Re_Weighment}' AND count <= 100 ORDER BY count`
           const data = await manager.query(infoQuery)
           return data
        }

        async getEnquiryDetailsForCostSheet(enquiryId:number){
        const manager=getManager()
            const enquiryInfoQry = `SELECT ec.end_customer_name AS buyer,c.client_name AS agent,cn.country_name AS country,e.country_id as countryId,e.destination_id as destinationId,dn.destination_name AS destination,st.shipping_term_name AS shipTerms,no_of_containers as noOfContainers,e.currency_id as currencyId,e.enquiry_date AS enquiryDate,sales_commision as saleCommissionPercentage,etd as shipmentPeriod,buyer_id as buyerId,order_type as leadType,life_cycle_status as enquiryStatus,e.enquiry_number as enquiryNumber,e.is_fob as isFOB
            FROM ${appSettings.enquiry_db}.enquiries e LEFT JOIN ${appSettings.masters_db}.customers c ON c.cust_id = e.agent_id
            LEFT JOIN ${appSettings.masters_db}.end_customers ec ON ec.end_customer_id = e.buyer_id
            LEFT JOIN ${appSettings.masters_db}.countries cn ON cn.country_id = e.country_id
            LEFT JOIN ${appSettings.masters_db}.destination dn ON dn.destination_id = e.destination_id
            LEFT JOIN ${appSettings.masters_db}.shipping_terms st ON st.shipping_term_id = e.shipment_terms_id where enquiry_id = ${enquiryId}`
            return  await manager.query(enquiryInfoQry)
        }

        async getEnquiryStatusInfo(enquiryId:number){
            const manager=getManager()
            const logInfoQry = `SELECT enquiry_number,
            MAX(CASE WHEN enquiry_status = 'ASSESMENT APPROVED' THEN DATE(created_at) ELSE NULL END) AS 'assesmentApprovalDate',
            MAX(CASE WHEN enquiry_status = 'QUOTATION SENT' THEN DATE(created_at) ELSE NULL END) AS 'QuoteSentDate',
            MAX(CASE WHEN enquiry_status = 'ACCEPTED' THEN DATE(created_at) ELSE NULL END) AS 'Accepteddate'
            FROM ${appSettings.enquiry_db}.enquiry_log WHERE enquiry_id = ${enquiryId}`
            return await manager.query(logInfoQry)
        }

        
        async getEnquiryDetailsById(req: EnquiryIdreq): Promise<any>{
            const manager = getManager()
            let query = 
            `SELECT e.enquiry_id AS enquiryId,e.source_from AS sourceFrom,e.enquiry_number as enquiryNumber,
            sku.short_code AS shortCode,sku.sku_code_id AS skuCodeId,
            e.agent_id AS agentId,c.client_name AS clientName,
            e.buyer_id AS buyerId,ec.end_customer_name AS endCustomerName,
            e.sale_person_id AS salePersonId, ed.employee_name AS employeeName,
            e.enquiry_date AS enquiryDate,e.etd,e.to_etd as toEtd,e.eta,
            e.agent_address_id AS agentAddressId,CONCAT(addr.add_line_one, addr.add_line_two, addr.add_line_three, addr.add_line_four) AS agentAddress,
            e.buyer_address_id AS buyerAddressId,CONCAT(baddr.add_line_one, baddr.add_line_two, baddr.add_line_three, baddr.add_line_four) AS buyerAddress,
            e.country_id AS countryId,cty.country_name AS countryName,
            e.destination_id AS destinationId,d.destination_name AS destinationName,
            e.delivery_terms_id AS deliveryTermsId,dt.delivery_terms_name AS deliveryTermsName,
            e.payment_terms_id AS paymentTermsId,pt.payment_terms_name as paymentTermsName,
            e.shipment_terms_id AS shipmentTermsId,st.shipping_term_name AS shippingTermName,
            e.processing_unit_id AS processingUnitId,puc.unit_name AS processingUnit,
            ep.order_type AS orderType,
            e.manufacturing_unit_id AS manufacturingUnitId,muc.unit_name AS manufacturingUnit,
            pl.plant_code as unitName,
            rsn.reasons_name AS rejectReason,
            e.currency_id AS currencyId,cur.currency_name as currencyName,
            e.no_of_containers AS noOfContainers,
            e.sales_commision AS salesCommission,
            e.remarks,e.uom_id as uomId,uom.uom_name as uom,pl.company,e.enquiry_reject_description as enqRejectDes,e.is_fob as isFOB
            FROM  `+appSettings.enquiry_db+`.enquiries e
            LEFT JOIN  `+appSettings.enquiry_db+`.enquiry_products ep ON ep.enquiry_product_id = e.enquiry_id
            LEFT JOIN  `+appSettings.masters_db+`.sku_codes sku ON sku.sku_code_id = ep.enquiry_product_id
            LEFT JOIN  `+appSettings.masters_db+`.customers c ON c.cust_id = e.agent_id
            LEFT JOIN  `+appSettings.masters_db+`.end_customers ec ON ec.end_customer_id = e.buyer_id
            LEFT JOIN  `+appSettings.masters_db+`.employee_details ed ON ed.employee_id=e.sale_person_id
            LEFT JOIN  `+appSettings.masters_db+`.address addr ON addr.address_id = e.agent_address_id
            LEFT JOIN  `+appSettings.masters_db+`.address baddr ON baddr.address_id = e.buyer_address_id
            LEFT JOIN  `+appSettings.masters_db+`.countries cty ON cty.country_id = e.country_id
            LEFT JOIN  `+appSettings.masters_db+`.destination d ON d.destination_id = e.destination_id
            LEFT JOIN  `+appSettings.masters_db+`.delivery_terms dt ON dt.delivery_terms_id = e.delivery_terms_id
            LEFT JOIN  `+appSettings.masters_db+`.payment_terms pt ON pt.payment_terms_id = e.payment_terms_id
            LEFT JOIN  `+appSettings.masters_db+`.shipping_terms st ON st.shipping_term_id = e.shipment_terms_id
            LEFT JOIN  `+appSettings.masters_db+`.unitcodes puc ON puc.unit_code_id = e.processing_unit_id
            LEFT JOIN  `+appSettings.masters_db+`.unitcodes muc ON muc.unit_code_id = e.manufacturing_unit_id
            LEFT JOIN  `+appSettings.masters_db+`.unitcodes pl ON pl.unit_code_id=e.unit_id
            LEFT JOIN  `+appSettings.masters_db+`.reasons rsn ON rsn.reasons_id=e.enquiry_reject_reason
            LEFT JOIN  `+appSettings.masters_db+`.currencies cur ON cur.currency_id = e.currency_id
            LEFT JOIN `+appSettings.masters_db+` .uoms uom ON uom.uom_id = e.uom_id
            WHERE e.enquiry_id = ${req.enquiryid}`
            const data = await manager.query(query)
            return data
        }

        async getProductByEnqId(req: EnquiryIdreq):Promise<any>{
            const manager = getManager()
            let query = 
            `SELECT ep.enquiry_product_id as productId,ep.enquiry_id AS enquiryId,ep.enquiry_product_id AS enquiryProductId,ep.category,
            ep.brand_id AS brandId,b.brand_name AS brandName,ep.pack_count as PackCount,
            ep.variant_id AS variantId, sc.variant_code AS variantName,sc.short_code AS shortCode,
            ep.pack_style_id AS packStyleId,pm.packing_method_name AS packStyleName,
            pm.uom_id AS uomId,u.uom_name AS uomName,
            ep.style_weighment AS styleWeighment,
            ep.unit_Price AS unitPrice,
            ep.no_of_case AS noOfCases,
            ep.case_weight AS caseWeight,
            ep.net_weight AS netWeight,
            ep.net_amount AS netAmount,
            ep.no_of_skewers AS noOfSkewers,
            ep.variety_id AS varietyId,s.size_name as varietyName,ep.net_shrimp_weight as netShrimpWeight,ep.pack_count as packCount,ep.pack_material_cost as packMaterialCost,ep.group,ep.no_of_containers as noOfContainers,ep.order_type as orderType,ep.brand_type as brandType,ep.uv_price_category,ep.uv_type,ep.uv_percent_or_cent,pm.no_of_pouches,pm.pouches_per_row,ep.price_based_on
            FROM  `+appSettings.enquiry_db+`.enquiry_products ep
            LEFT JOIN  `+appSettings.enquiry_db+`.enquiries e ON e.enquiry_id = ep.enquiry_id
            LEFT JOIN  `+appSettings.masters_db+`.brands b ON b.brand_id = ep.brand_id
            LEFT JOIN  `+appSettings.masters_db+`.sku_codes sc ON sc.sku_code_id = ep.variant_id
            LEFT JOIN  `+appSettings.masters_db+`.packing_methods pm ON pm.packing_method_id = ep.pack_style_id
            LEFT JOIN  `+appSettings.masters_db+`.sizes s ON s.size_id = ep.variety_id
            LEFT JOIN  `+appSettings.masters_db+`.uoms u ON u.uom_id = pm.uom_id   
            WHERE ep.enquiry_id = ${req.enquiryid}`
            const data = await manager.query(query)
            return data
        }

        async getPackBomByEnqId(req: EnquiryIdreq):Promise<any>{
            const manager = getManager()
            let query = 
            `SELECT epb.id,epb.item_category_id AS itemCategoryId,ic.item_category AS itemCategory,
            epb.item_sub_category_id AS itemSubCategoryId,isc.item_sub_category AS itemSubCategory,
            epb.item_id AS itemId,i.item_name AS itemName,
            epb.quantity,epb.enquiry_id AS enquiryId
            FROM `+appSettings.enquiry_db+`.enquiry_pack_bom epb
            LEFT JOIN `+appSettings.enquiry_db+`.enquiries e ON e.enquiry_id = epb.enquiry_id
            LEFT JOIN `+appSettings.masters_db+`.item_categories ic ON ic.item_category_id = epb.item_category_id
            LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = epb.item_sub_category_id
            LEFT JOIN `+appSettings.masters_db+`.items i ON i.item_id = epb.item_id
            WHERE epb.enquiry_id = ${req.enquiryid}`
            const data = await manager.query(query)
            return data
        }

        //-----------commented as prrev confirmed price need to be fetch from saleorder instead of enquiries
    // async getPrevConfirmedEnquiries(variantIds:any[]){
    //     const manager = getManager()
    //     const prevConfirmedEnquiriesQry = `SELECT variant_id as variantId,buyer_id as buyerId,unit_price as unitPrice,e.life_cycle_status,category,ep.uom_id as uomId,case_weight as caseWeight FROM ${appSettings.enquiry_db}.sale_order ep left join ${appSettings.enquiry_db}.enquiries e on e.enquiry_id = ep.enquiry_id WHERE ep.variant_id IN(${variantIds}) and e.life_cycle_status = '${EnquiryLifecycleStatusEnum.ACCEPTED}'`
    //     return await manager.query(prevConfirmedEnquiriesQry)

    // }
    // async getSameBuyerConfirmedEnquiries(variantIds:any[],buyerId:number){
    //     const manager = getManager()
    //     const prevConfirmedEnquiriesQry = `SELECT variant_id as variantId,buyer_id as buyerId,unit_price as unitPrice,e.life_cycle_status,category,ep.uom_id as uomId,case_weight as caseWeight FROM ${appSettings.enquiry_db}.enquiry_products ep left join ${appSettings.enquiry_db}.enquiries e on e.enquiry_id = ep.enquiry_id WHERE ep.variant_id IN(${variantIds}) and e.life_cycle_status = '${EnquiryLifecycleStatusEnum.ACCEPTED}' and e.buyer_id = ${buyerId} order by e.created_at desc`
    //     return await manager.query(prevConfirmedEnquiriesQry)

    // }
    //---------------

    async getPrevConfirmedEnquiries(variantIds:any[]){
        const manager = getManager()
        const prevConfirmedEnquiriesQry = `SELECT varient_id as variantId,end_customer_id as buyerId,unitPrice as unitPrice,ep.category,ep.price_based_on as uomId,case_weight as caseWeight FROM ${appSettings.sales_db}.sale_order_items ep left join ${appSettings.sales_db}.so_invoice_details e on e.sale_order_id = ep.sale_order_id WHERE ep.varient_id IN(${variantIds})`
        return await manager.query(prevConfirmedEnquiriesQry)

    }

    async getSameBuyerConfirmedEnquiries(variantIds:any[],buyerId:number){
        const manager = getManager()
        const prevConfirmedEnquiriesQry = `SELECT varient_id as variantId,end_customer_id as buyerId,unitPrice as unitPrice,ep.category,ep.price_based_on as uomId,case_weight as caseWeight FROM ${appSettings.sales_db}.sale_order_items ep left join ${appSettings.sales_db}.so_invoice_details e on e.sale_order_id = ep.sale_order_id WHERE ep.varient_id IN(${variantIds}) and e.end_customer_id = ${buyerId} order by e.created_at desc`
        return await manager.query(prevConfirmedEnquiriesQry)

    }

    async getEnquiryDropdownForEnquiryAssessment():Promise<any>{
        const infoQuery = this.createQueryBuilder('e')
        .select(`enquiry_number as enquiryNumber,enquiry_id as enquiryId, freeze_status as freezeStatus`)
        .where(`life_cycle_status IN('${EnquiryLifecycleStatusEnum.OPEN}','${EnquiryLifecycleStatusEnum.UNDER_ASSESMENT}','${EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED}')`)
        .groupBy(`enquiry_id`)
        return await infoQuery.getRawMany()
    }

    async getCostSheetEnquiryNumberDropdown():Promise<any>{
        const infoQuery = this.createQueryBuilder('e')
        .select(`enquiry_number as enquiryNumber,enquiry_id as enquiryId, freeze_status as freezeStatus`)
        .where(`life_cycle_status IN('${EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED}','${EnquiryLifecycleStatusEnum.COSTING_APPROVED}','${EnquiryLifecycleStatusEnum.ACCEPTED}','${EnquiryLifecycleStatusEnum.RENEGOTIATED}','${EnquiryLifecycleStatusEnum.QUOTATION_SENT}','${EnquiryLifecycleStatusEnum.ACCEPTANCE_PENDING}')`)
        .groupBy(`enquiry_id`)
        return await infoQuery.getRawMany()
    }

    async getFreezeUnFreezeEnquiryNumberDropdown(req:FreezeUnFreezeInfoReq):Promise<any>{
        let infoQuery = this.createQueryBuilder('e')
        .select(`enquiry_number as enquiryNumber,enquiry_id as enquiryId, freeze_status as freezeStatus`)
        if(req.tabName == 'Freezed'){
            infoQuery.where(`freeze_status = 1`) 
        }
        if(req.tabName == 'UnFreezed'){
            infoQuery.where(`life_cycle_status IN('${EnquiryLifecycleStatusEnum.ASSESMENT_APPROVED}','${EnquiryLifecycleStatusEnum.COSTING_APPROVED}','${EnquiryLifecycleStatusEnum.RENEGOTIATED}','${EnquiryLifecycleStatusEnum.QUOTATION_SENT}','${EnquiryLifecycleStatusEnum.ACCEPTANCE_PENDING}')`)
        }
        infoQuery.groupBy(`enquiry_id`)
        return await infoQuery.getRawMany()
    }
}

    
